import React from 'react';
import PropTypes from 'prop-types';
import Link from 'components/Link';
import classNames from 'classnames';
import classes from './SiteNavADesktopLevelD.module.scss';

const SiteNavADesktopLevelD = ({ items = [] }) => (
  <div className={classes.container}>
    <div className={classes.wrapper}>
      <div className={classes.linkList}>
        {items.map((item) => (
          <Link
            href={item.href}
            target={item.target}
            className={classNames(classes.navItem, { [classes.active]: item.isActive })}
            key={item.href}
            dangerouslySetInnerHTML={{ __html: item.heading }}
          />
        ))}
      </div>
    </div>
  </div>
);

SiteNavADesktopLevelD.propTypes = {
  items: PropTypes.array.isRequired,
};

export default SiteNavADesktopLevelD;
